import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import Auth from "../../Auth/Auth";
import UserActions from "../../Action/Actions/UserActions";
import SignoutActions from "../../Action/Actions/SignoutActions";
// import Http from "../../Http/Http";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Socket from "../../Socket/Socket";

export default function* signout(action: ActionInterface): any {
  try {
    yield put(SignoutActions.request());
    // yield call(Http.get, "auth/signout");
    yield call(Auth.signout);
    yield Socket.unsubscribe();
    yield call(Auth.signoutRedirect);
    yield put(UserActions.signout(action.payload));

    // (window as any).HelpCrunch('logout', function(data) {
    //   if (data && data.success) {
    //     (window as any).HelpCrunch('hideChatWidget');
    //   }
    // });

    yield put(SignoutActions.success());
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SIGNOUT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchSignout() {
  yield takeEvery(Constants.PAGE_SIGNOUT_START, signout);
}
